/**
 * Please see `docs/architectures/core.md`
 */
export enum ExceptionStatus {
  NOT_FOUND = 100,
  NOT_PUBLIC = 101,
  FULLED = 102,
  INVALID_DURATION = 103,
  MISSING_DEFAULT_ANSWER = 104,
  INVALID_DEFAULT_ANSWER = 105,
  MASTER_SURVEY_IS_NOT_EXISTED = 106,
  MASTER_SURVEY_IS_OFF = 107,
  INVALID_SUBMIT_DURATION = 108,
  INVALID_ANSWER_OBJECT = 109,
  INVALID_PRO_SURVEY = 110,
  INVALID_TEMPORARY_SURVEY = 111,
  NOT_ALLOWED = 112
}
